<div fxLayout="column" fxFlexFill>
  <div fxFlex><router-outlet></router-outlet>
  </div>
  <!--<footer *ngIf="!start"><gd-player></gd-player></footer>-->
  <footer>
    <gd-player></gd-player>
    <app-cookie-banner></app-cookie-banner>
  </footer>
</div>
